import { useSyncExternalStore } from 'react';

const subscribeNoop = () => () => {};

/**
 * Returns `false` on the server and during the first client (hydration)
 * render, then `true` on every render after mount.
 *
 * Auth-aware, self-fetching blocks read the current user from client-only
 * state (redux-persist), so `useCurrentUser()` can be `null` on the server
 * yet populated on the client. Branching on it during hydration (auth gates,
 * identity rows, `useId`-keyed `<style>` tags) makes the server HTML and the
 * first client render disagree, and React throws the whole subtree away.
 *
 * Gate such blocks on this flag — render a stable placeholder (usually
 * `null`) until mounted — so both renders agree and the real, personalized
 * content appears one tick later on the client. Uses `useSyncExternalStore`
 * (not `useState` + `useEffect`) so the server snapshot is `false` with no
 * extra commit.
 */
export function useMounted(): boolean {
  return useSyncExternalStore(
    subscribeNoop,
    () => true,
    () => false,
  );
}
